// extracted by mini-css-extract-plugin
module.exports = {"grid":"_1Yfth"};